'use-strict';

/* @ngInject */
export default function ProfileImageUploadController(
  $scope,
  usersService,
  settingsApiService,
  $route,
  toastService,
) {
  $scope.newProfileImage = {};

  const init = () => {
    $scope.previewId = $scope.userId !== undefined ? $scope.userId : usersService.currentUserId();
    $scope.showPreview = true;
  };

  $scope.uploadProfileImage = () => {
    if ($scope.newProfileImage.file === undefined) return;

    settingsApiService.uploadProfileImage($scope.newProfileImage.file, $scope.previewId)
      .then(() => {
        toastService.toast('success', 'Profilbild wurde hochgeladen');
        $route.reload();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  init();
}
